export default {

	"step_1_appeal": {
		"en": "Ladies and Gentlemen",
		"pl": "Szanowni Państwo",
		"ru": "Уважаемые клиенты",
		"ua": "Шановні Клієнти"
	},

	"step_1_info_text": {
		"en": "In order to book an appointment, please select: service centre, type of service, planned date and time of a visit, as well as a method of booking confirmation. After filling in the form and clicking the \"Book\" button, your appointment will be booked and a confirmation of the visit will be sent via an e-mail or text message.",
		"pl": "Aby zarezerwować wizytę, należy wybrać miejsce, odpowiednią grupę spraw, dzień, godzinę planowanej wizyty oraz sposób potwierdzenia rezerwacji. Po wypełnieniu formularza, a następnie wybraniu przycisku \"Rezerwuj\" Twoja wizyta zostanie zarezerwowana, a na podany adres e-mail lub numer telefonu zostanie wysłane potwierdzenie rezerwacji wizyty.",
		"ru": "Чтобы записаться на прием, выберите место, соответствующую категорию услуг, день, время планируемого визита и способ подтверждения регистрации. После заполнения формы и нажатия кнопки \"Забронировать\", ваше посещение будет забронировано, а на указанный адрес электронной почты или номер телефона будет отправлено подтверждение бронирования.",
		"ua": "Для бронювання візиту необхідно вибрати місце, відповідну групу справ, день, час запланованого візиту і спосіб підтвердження бронювання. Після заповнення форми та вибору кнопки \"Забронювати\" Ваш візит буде заброньовано, а на вказану електронну  адресу або номер телефону буде відправлено підтвердження бронювання."
	},

	"step_1_info_1_1": {
		"en": "• Before scheduling an in-person visit, please check if you can be served online in the Public Information Bulletin.",
		"pl": "• Przed rezerwacją wizyty sprawdź w Biuletynie Informacji Publicznej czy Twojej sprawy, nie można zrealizować elektronicznie.",
		"ru": "• Перед бронированием визита проверьте в Бюллетене общественной информации, не может ли Ваше дело быть рассмотрено онлайн.",
		"ua": "• Перед бронюванням візиту перевірте в Бюлетені Публічної Інформації, чи Вашу справу не можна вирішити в електронному вигляді."
	},
	
	"step_1_info_1_2": {
		"en": "• If you schedule a visit online, you will have to arrive at the selected time.",
		"pl": "• Rezerwacja wizyty przez Internet skutkuje koniecznością przybycia w wybranym terminie.",
		"ru": "• После бронирования визита онлайн необходимо появиться в Управлении в выбранный день и время.",
		"ua": "• Бронювання візиту через інтернет призводить до необхідності прибуття в обраний день та час."
	},

	"step_1_info_1_3": {
		"en": "• One appointment = one service. If you want to settle more matters, book more visits.",
		"pl": "• Jedna zarezerwowana wizyta = jedna sprawa. Chcesz załatwić więcej spraw – zarezerwuj więcej wizyt.",
		"ru": "• Один забронированный визит = одна услуга. В случае, если Вы хотите воспользоваться несколькими услугами – забронируйте несколько визитов.",
		"ua": "• Один заброньований візит = один випадок. Якщо Ви хочете вирішити більше справ – забронюйте більше візитів."
	},

	"step_1_info_1_4": {
		"en": "• During one visit regarding vehicle registration, you can register only 1 vehicle.",
		"pl": "• W grupie rejestracja pojazdów podczas jednej rezerwacji można zarejestrować max. 1 pojazd.",
		"ru": "• В категории \"Регистрация автомобиля\" с помощью одного бронирования Вы можете зарегистрировать максимально 1 автомобиль.",
		"ua": "• У групі реєстрації транспортних засобів при одному бронюванні можна зареєструвати максимум 1 транспортний засіб."
	},

	"step_1_info_1_5": {
		"en": "• Come no earlier than 10 minutes before your appointment.",
		"pl": "• Przyjdź nie wcześniej niż 10 minut przed umówioną wizytą.",
		"ru": "• Приходите не ранее, чем за 10 минут до назначенного визита.",
		"ua": "• Приходьте не раніше ніж за 10 хвилин до призначеного візиту."
	},

	"step_1_info_1_6": {
		"en": "• Bring your documents, completed application forms, and, if necessary, your payment with you.",
		"pl": "• Przyjdź z przygotowanymi dokumentami, wypełnionymi wnioskami, jeśli to konieczne z opłatą.",
		"ru": "• Приходите с подготовленными документами, заполненными формами, при необходимости – после оплаты услуги.",
		"ua": "• Приходьте з підготовленими документами, заповненими заявками, при необхідності - з оплатою."
	},

	"step_1_info_1_7": {
		"en": "• If presence of other people is not required, come alone.",
		"pl": "• Jeśli sprawa nie wymaga wizyty większej liczby osób, przyjdź w pojedynkę.",
		"ru": "• Если дело не требует присутствия других людей, приходите одни.",
		"ua": "• Якщо справа не вимагає відвідування більшої кількості людей, приходьте поодинці."
	},

	"step_1_info_1_8": {
		"en": "• isits are arranged one week in advance. Dates for the following days are made available every Friday from 7:00 am.",
		"pl": "• Wizyty umawiane są z tygodniowym wyprzedzeniem. Terminy na kolejne dni udostępniane są co piątek od godziny 7:00.",
		"ru": "• О визитах договариваются за неделю. Даты на следующие дни доступны каждую пятницу с 7:00.",
		"ua": "• Візити організуються за тиждень наперед. Дати на наступні дні доступні щоп’ятниці з 7:00."
	},

	"step_1_warning": {
		"en": "Visitors are required to wear a face covering. Due to the need to sign documents, it is recommended to wear protective gloves.",
		"pl": "Do budynków będą mogły wejść wyłącznie osoby z zakrytym nosem i ustami. Ze względu na podpisywanie dokumentów urzędowych, zaleca się posiadanie rękawiczek.",
		"ru": "В здания могут входить только люди с прикрытыми носом и ртом. В связи с подписанием официальных документов рекомендуется иметь при себе перчатки.",
		"ua": "У будівлю зможуть входити тільки особи з прикритим носом і ротом. У зв'язку з підписанням офіційних документів рекомендується мати рукавички."
	},
}